import { setLoggerConfig } from '@silae/helpers';
import { parseEnvVariable } from '~/utils';

const enabled = parseEnvVariable(import.meta.env.SILAE_ENABLE_LOGS) as boolean;
const level = import.meta.env.SILAE_LOG_LEVEL;
export function setupLogger() {
	setLoggerConfig({ level, enabled, collapsed: false });
}
